import OutlinedInputMixin from './outlined-input-mixin.js';
import ErrorTextMixin from './error-text-mixin.js';
import DisableableMixin from './disableable-mixin.js';
import FloatingLabelForOutlinedInputMixin from './labels/floating-label-for-outlined-input-mixin.js';
import FocusableMixin from './focusable-mixin.js';
import HelperTextMixin from './helper-text-mixin.js';
import InputStateContainerMixin from './input-state-container-mixin.js';
import LabelMixin from './labels/label-mixin.js';
import PlaceholderMixin from './placeholder-mixin.js';
import ThemedInputMixin from './themed-input-mixin.js';

function OutlinedFloatingLabelInputMixin(Base) {

  return class OutlinedFloatingLabelInput extends
    OutlinedInputMixin(
    InputStateContainerMixin(
    ErrorTextMixin(
    HelperTextMixin(
    FloatingLabelForOutlinedInputMixin(
    LabelMixin(
    FocusableMixin(
    DisableableMixin(
    PlaceholderMixin(
    ThemedInputMixin(
      Base
  )))))))))) {}
}

export default OutlinedFloatingLabelInputMixin;
